import React from 'react';
import Maincontentbottom from './main-content-bottom'

function Maincontent() {
  return (
    <div className="main-content">
      <Maincontentbottom/>
    </div>
  );
}

export default Maincontent;
